module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-30-6b972a31bef0fbda9fdffaa5273cd95a.png";